export default __webpack_public_path__ + "static/media/occamfi.2f854fc9.svg";